import { render, staticRenderFns } from "./AccountMenuEntry.vue?vue&type=template&id=ef2c9556&scoped=true"
import script from "./AccountMenuEntry.vue?vue&type=script&lang=ts"
export * from "./AccountMenuEntry.vue?vue&type=script&lang=ts"
import style0 from "./AccountMenuEntry.vue?vue&type=style&index=0&id=ef2c9556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2c9556",
  null
  
)

export default component.exports